<script setup lang="ts">
import {defineProps, ref} from "vue";
import FleetActions from '@/components/Sections/Command/Fleets/FleetDetails/FleetActions.vue'
import ShipsList from '@/components/Sections/Command/Ships/ShipsList.vue'
import FleetDisband from '@/components/Sections/Command/Fleets/FleetDetails/FleetDisband.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  fleetId: {
    type: Number,
    required: true
  }
});

const currentTab = ref('actions')

</script>

<template>
  <div class="text-sm font-medium text-center border-b text-metal-300 border-metal-700">
    <ul class="flex flex-wrap">
      <li class="me-2">
        <a href="#"
           :class="{
               'active-blue': currentTab === 'actions',
               'text-blue-500 border-blue-500': currentTab === 'actions',
               'text-metal-500 border-transparent': currentTab !== 'actions',
               'inline-block p-4 border-b-2 rounded-t-lg hover:border-metal-300 hover:text-metal-300': true
           }"
           @click="currentTab = 'actions'">
          {{ t('command.fleetTabs.actions') }}
        </a>
      </li>
      <li class="me-2">
        <a href="#"
           :class="{
               'active-blue': currentTab === 'ships',
               'text-blue-500 border-blue-500': currentTab === 'ships',
               'text-metal-500 border-transparent': currentTab !== 'ships',
               'inline-block p-4 border-b-2 rounded-t-lg hover:border-metal-300 hover:text-metal-300': true
           }"
           @click="currentTab = 'ships'">
          {{ t('command.fleetTabs.ships') }}
        </a>
      </li>
      <li class="me-2">
        <a href="#"
           :class="{
               'active-red': currentTab === 'disband',
               'text-red-500 border-red-500': currentTab === 'disband',
               'text-metal-500 border-transparent': currentTab !== 'disband',
               'inline-block p-4 border-b-2 rounded-t-lg hover:border-metal-300 hover:text-metal-300': true
           }"
           @click="currentTab = 'disband'">
          {{ t('command.fleetTabs.disband') }}
        </a>
      </li>
    </ul>
  </div>
  <div v-if="currentTab === 'ships'" class="content-height-limit-fleet-details pt-2 ">
    <ShipsList :withDetails="false" :lockedToFleetId="props.fleetId" class="mt-2"></ShipsList>
  </div>
  <div v-if="currentTab === 'actions'" class="content-height-limit-fleet-details overflow-y-auto">
    <FleetActions :fleetId="props.fleetId" />
  </div>
  <div v-if="currentTab === 'disband'" class="content-height-limit-fleet-details overflow-y-auto">
    <FleetDisband :fleetId="props.fleetId" />
  </div>
</template>

<style scoped lang="scss">
.nav-item {
  cursor: pointer;
}

.active-blue {
  background: linear-gradient(
    to top,
    rgba(59, 130, 246, 0.3) 0%,
    rgba(59, 130, 246, 0) 70%
  );
}

.active-red {
  background: linear-gradient(
    to top,
    rgba(239, 68, 68, 0.3) 0%,
    rgba(239, 68, 68, 0) 70%
  );
}
</style>
